import { useState, useEffect } from "react";
import Navbar from "./Navbar";
import PolicyTab from "./PolicyTab";
import ProceduresTab from "./ProceduresTab";
import ScreeningTab from "./ScreeningTab";
import RecordTab from "./RecordTab";
import GovernanceTab from "./GovernanceTab";
import OnboardingTab from "./OnboardingTab";

function Dashboard({ username, role, onLogout }) {
  const [activeTab, setActiveTab] = useState("policy");

  // ✅ Shared policies state lifted here so L1 → L2 → L3 see the same data
  //    Persisted to localStorage so when you log out as L1 and log in as L2, it's still there.
  const [policies, setPolicies] = useState(() => {
    try {
      const stored = localStorage.getItem("policies");
      if (stored) return JSON.parse(stored);
    } catch {}
    // Default: one AML pending policy, same as your original flow
    return [
      {
        id: 1,
        name: "Anti-Money Laundering (AML) Policy",
        status: "pending",            // pending | draft | forwarded | approved | rejected | final (if you ever use)
        document: null,               // blob url when draft/final generated
        remarks: "",                  // L2 remarks on approve/reject
        preparedBy: null,             // { name, designation } (when L1 generates draft)
        approvedBy: null,             // { name, designation } (when L2 approves)
      },
    ];
  });

  // Persist (except blob URL which isn't stable across reloads)
  useEffect(() => {
    try {
      const serializable = policies.map(({ document, ...rest }) => rest);
      localStorage.setItem("policies", JSON.stringify(serializable));
    } catch {}
  }, [policies]);

  // Keep original renderTab structure & UI EXACTLY the same; just pass policies + setPolicies to PolicyTab.
  const renderTab = () => {
    switch (activeTab) {
      case "policy":
        return (
          <PolicyTab
            role={role}
            policies={policies}
            setPolicies={setPolicies}
          />
        );
      case "procedures":
        return <ProceduresTab />;
      case "screening":
        return <ScreeningTab />;
      case "record":
        return <RecordTab />;
      case "governance":
        return <GovernanceTab />;
      case "onboarding":
        return <OnboardingTab role={role} />;
      default:
        return (
          <PolicyTab
            role={role}
            policies={policies}
            setPolicies={setPolicies}
          />
        );
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f4f6f8",
        fontFamily: "Arial, sans-serif",
      }}
    >
      {/* Header — unchanged */}
      <header style={{ 
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "15px 30px",
                      backgroundColor: "#0d47a1",
                      color: "white",
                    }}>
        {/* <img src="/logo.png" alt="GNXi Logo" style={{ height: "40px" }}/> */}
        <h2>AMLi</h2>
        <div>
          <span style={{ marginRight: 20 }}>
            {username} (Role: {role})
          </span>
          <button
            onClick={onLogout}
            style={{
              backgroundColor: "#f44336",
              color: "white",
              border: "none",
              padding: "8px 16px",
              borderRadius: 6,
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            Logout
          </button>
        </div>
      </header>
      <>
            <div>
            <p style={{ fontSize: 24, color: "#0d47a1" }}>
              Welcome to the AMLi Dashboard
            </p>
            </div>
      </>

      {/* Navbar — unchanged */}
      <Navbar activeTab={activeTab} setActiveTab={setActiveTab} />

      {/* Content — unchanged */}
      <main style={{ padding: 20 }}>{renderTab()}</main>
    </div>
    
  );
}

export default Dashboard;
